import React from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import { Transition } from 'react-transition-group';
import { Icon } from '../icon';
import { useWindowSize } from '../../hooks/window-size';
import { AnimationOnTop } from '../animation';
import { makeErrorIcon, makeNotification, makeSuccesIconNotification } from './mixins';
const ErrorIcon = styled.div `
  ${() => makeErrorIcon()}
`;
const SuccesIconNotification = styled(Icon) `
  ${() => makeSuccesIconNotification()}
`;
const Notification = styled.div `
  ${(props) => makeNotification(props)}
`;
export const Snackbar = ({ visible, snackbaroptions, children }) => {
    const { isMobile } = useWindowSize();
    const { type = 'notificarion', icon, timer, animation } = Object.assign({}, snackbaroptions);
    return ReactDOM.createPortal(React.createElement(Transition, { in: visible, onEntering: visible && timer, mountOnEnter: true }, (state) => (
    // state change: exited -> entering -> entered -> exiting -> exited
    React.createElement(AnimationOnTop, { name: animation, className: `animation-${state}` },
        React.createElement(Notification, { width: isMobile && window.innerWidth - 32, type: type },
            type === 'error' && (React.createElement(ErrorIcon, null,
                React.createElement(Icon, { name: "icon-light-alert-triangle", color: "white", size: "24" }))),
            children,
            icon && React.createElement(SuccesIconNotification, { name: icon, color: "white", size: "24" }))))), document.getElementById('floating-elements'));
};
